{
  "pageTitle": "Hent eller opprett leverandørnummer",
  "backLinkLabel": "Tilbake til eiendom",
  "cardTitle": "Har skogeier en profil i Skogdata?",
  "cardDescription": "Velg om skogeier har en eksisterende profil i Skogdata eller ikke",
  "noProfile": {
    "label": "Nei - skogeieren har ikke en profil i Skogdata",
    "description": "Ny profil opprettes i Skogdata, og nødvendige leverandørnumre genereres automatisk."
  },
  "yesProfile": {
    "label": "Ja - skogeieren har en eksisterende profil i Skogdata",
    "description": "Legg inn organisasjonsnummeret i neste steg. Eksisterende leverandørnumre hentes, og nye opprettes ved behov."
  },
  "cancelConfirm": {
    "title": "Er du sikker på at du vil avbryte henting/oppretting av leverandørnummer?",
    "description": "All informasjon du har fylt ut vil gå tapt og må fylles inn på nytt.",
    "continueEditing": "Gå tilbake",
    "discardChanges": "Avbryt uten å lagre"
  },
  "confirmStep": {
    "title": "Er du sikker på at du vil opprette ny skogdataprofil for {{name}}?",
    "description": "En ny profil vil bli opprettet i Skogdata. Dette kan ikke angres.",
    "goBack": "Gå tilbake",
    "createProfile": "Opprett profil"
  },
  "orgNumberStep": {
    "cardTitle": "Legg inn organisasjonsnummer",
    "cardDescription": "Skriv inn organisasjonsnummeret. Eksisterende leverandørnumre hentes, og nye opprettes ved behov.",
    "inputLabel": "Organisasjonsnummer",
    "inputDescription": "Skriv inn 9 siffer (123456789) eller med landkode (NO123456789)",
    "searching": "Søker etter organisasjon...",
    "formatError": "Organisasjonsnummer må være 9 eller 16 siffer",
    "notFoundError": "Fant ikke organisasjonsnummeret i Skogdata. Sjekk nummeret og forsøk på nytt"
  },
  "loadingStep": {
    "messageNo": "Oppretter i Skogdata...",
    "messageYes": "Henter informasjon fra Skogdata...",
    "messageSaving": "Legger til leverandørnumre..."
  },
  "supplierSelectionStep": {
    "cardTitle": "Velg leverandørnumre",
    "cardDescription": "Noen kommuner har flere tilgjengelige leverandørnumre. Velg ett leverandørnummer per kommune.",
    "saveButton": "Lagre og fullfør",
    "selectPlaceholder": "Velg leverandørnummer",
    "requiredError": "Leverandørnummer må velges",
    "cancelConfirm": {
      "title": "Er du sikker på at du vil gå tilbake?",
      "description": "Valgene dine vil ikke bli lagret.",
      "discardChanges": "Gå tilbake uten å lagre"
    }
  },
  "receiptStep": {
    "title": "Oppsummering",
    "descriptionNo": "Det er generert et fiktivt organisasjonsnummer og nye leverandørnumre i Skogdata.",
    "descriptionYes": "Eksisterende leverandørnumre er hentet, og nye er opprettet for kommuner uten eksisterende leverandørnummer.",
    "organizationNumberLabel": "Fiktivt organisasjonsnummer",
    "existingOrganizationNumberLabel": "Organisasjonsnummer",
    "supplierNumber": "Opprettet leverandørnummer",
    "municipality": "Kommune"
  },
  "errorStep": {
    "generic": "Noe gikk galt ved kontakt med Skogdata. Vennligst prøv igjen, eller kontakt support hvis problemet vedvarer.",
    "timeout": "Skogdata svarer ikke. Vennligst prøv igjen.",
    "retry": "Prøv igjen"
  }
}
